import { render, staticRenderFns } from "./ManageUserAssignmentsDialog.vue?vue&type=template&id=09569fce"
import script from "./ManageUserAssignmentsDialog.vue?vue&type=script&lang=js"
export * from "./ManageUserAssignmentsDialog.vue?vue&type=script&lang=js"
import style0 from "./ManageUserAssignmentsDialog.vue?vue&type=style&index=0&id=09569fce&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports